
import animate from '@/utils/animate'

export default {
  name: 'ModalBase',

  props: {
    primaryButtonText: { type: String, default: 'Confirm' },
    primaryButtonIcon: { type: String, default: 'none' },
    secondaryButtonText: { type: String, default: 'Cancel' },
    icon: { type: String, default: 'checkmark' },
    isLoading: { type: Boolean, default: false },
    isCompact: { type: Boolean, default: false },
    position: { type: String, default: 'rightTop' },
    width: { type: Number, default: 340 },
  },

  methods: {
    open() {
      const {modal, wrapper, bg, body} = this.$refs;
      const distanceFactor = this.isCompact ? 0.5 : 1;
      modal.classList.remove('hidden');
      wrapper.classList.add('pointer-events-auto');
      animate(bg, {opacity: [0, 1]}, 200);
      animate(wrapper, {opacity: [0, 1]}, 200, 300);
      animate(body, {opacity: [0.75, 1]}, 50, 300);
      animate(body, {translateY: [-100 * distanceFactor, 0]}, 50, 300);
      document.addEventListener('keydown', this.escHandler, true)
    },

    confirm() {
      this.quit();
      this.onConfirm();
    },

    quit() {
      const {wrapper, body, bg} = this.$refs;
      const distanceFactor = this.isCompact ? 0.5 : 1;
      animate(body, {translateY: [0, -50 * distanceFactor]}, 300);
      animate(wrapper, {opacity: [1, 0]}, 300);
      animate(bg, {opacity: [1, 0]}, 300, 100);
      setTimeout(() => this.$el.remove(), 500);
    },

    escHandler(event) {
      if (event.keyCode === 27) { // ESC key
        this.quit();
        event.preventDefault();
        event.stopPropagation();
        document.removeEventListener('keydown', this.escHandler, true)
      }
    },

    clickPrimary() {
      this.$emit('clickPrimary')
    },

    clickSecondary() {
      this.$emit('clickSecondary')
    },
  }

}
